import React from "react";
import { useNavigate } from "react-router-dom";

const ErrorPage = () => {
  const Navigate = useNavigate();
  return (
    <div className="flex flex-col items-center justify-center py-12 bg-gray-100">
      <div className="max-w-md p-6 bg-white rounded-lg shadow-lg">
        <h1 className="text-4xl font-bold text-red-500">Oops!</h1>
        <p className="mt-4 text-gray-700">Something went wrong.</p>
        <p className="mt-2 text-gray-700">Please try again later.</p>
        <button
          className="mt-6 px-4 py-2 font-semibold text-white bg-primary rounded hover:bg-red-600 focus:bg-red-600 focus:outline-none"
          onClick={() => Navigate("/")}
        >
          Go To Home
        </button>
      </div>
    </div>
  );
};

export default ErrorPage;
